export interface RuntimeConfig {
  apiUrl: string;
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  linkedInExtensionUrl?: string;
}

let _config: RuntimeConfig | null = null;

export async function loadConfig(): Promise<void> {
  const res = await fetch('/runtimeConfiguration.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Failed to load runtime config: ${res.status}`);
  _config = (await res.json()) as RuntimeConfig;
}

export function getConfig(): RuntimeConfig {
  if (!_config) throw new Error('Runtime config not loaded');
  return _config;
}

// Single source of truth for the API base. `apiUrl` is the API root (e.g. "/api");
// the version is appended here so the request interceptor and the bootstrap default
// agree. Resolved at call time, so it is safe to use before/after config load order.
export function getApiBaseUrl(): string {
  return `${getConfig().apiUrl}/v1`;
}
